function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "25.8,54.9 22.8,54.9 22.8,37.2 5.1,37.2 5.1,34.2 25.8,34.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 10.7,
  y: 30.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 37.387 5.4072)",
  width: 3,
  height: 34.4
})))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "25.8,25.8 5.1,25.8 5.1,22.8 22.8,22.8 22.8,5.1 25.8,5.1  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: -5,
  y: 10.7,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 12.1662 -5.0396)",
  width: 34.4,
  height: 3
})))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "54.9,25.8 34.2,25.8 34.2,5.1 37.2,5.1 37.2,22.8 54.9,22.8  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 46.3,
  y: -5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 22.613 -30.26)",
  width: 3,
  height: 34.4
})))));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "37.2,54.9 34.2,54.9 34.2,34.2 54.9,34.2 54.9,37.2 37.2,37.2  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 30.6,
  y: 46.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 47.833 -19.8132)",
  width: 34.4,
  height: 3
})))));

var SvgCenterArrows = function SvgCenterArrows(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/center-arrows.1acb875c.svg";
export { SvgCenterArrows as ReactComponent };